// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Escolha um tema',
  dark: 'Escuro',
  light: 'Claro',
} as ILanguage;
